import React from 'react'

export const virginiaSetupVars = {
  siteId: 'virginia',
  topScreenshotUrl: '/images/iowa/marketing/Images/Mockup@2x.png',
  pathPrefix: '/va',
  menuHeader: "Discover Virginia's Solution for:",
  appUrl: 'https://va.headed2.com',
  logoImg: '/images/assets/virginia/horizontal/dark.svg',
  headerTitle: `The Virginia CareerExplorer is a system designed for Virginia`,
  headerTitleDescription: (
    <div>
      <p>
        With information and reporting designed to support career readiness for Virginia's
        in-demand careers.
      </p>
      <h4>
        With a <b>FREE</b> Headed2 account, you will have access to:
      </h4>
      <ul className="top-features">
        <li className="onetprofile">Occupation & College Info</li>
        <li className="financial-literacy">Financial Literacy Tools</li>
        <li className="onetassess">Self Assessments</li>
        <li className="plantool">Planning Tools</li>
      </ul>
    </div>
  ),
  sponsorMsg: (
    <span>
      The <b>Virginia CareerExplorer</b> is a state-approved Career Information and
      Decision-making System designed to support the development of students’ Individual
      Career and Academic Plan (ICAP).
    </span>
  ),
  brochureDownloadUrl:
    'https://drive.google.com/uc?export=download&id=1tTu1lfWizmF1brcQT04ObihBP59CJevZ',
  otherSites: [
    {
      url: 'https://www.cacareerzone.org',
      logoSrc: '/images/arkansas/marketing/Images/Export/CCZ-logo.svg'
    },
    {
      url: 'https://www.pacareerzone.org',
      logoSrc: '/images/arkansas/marketing/Images/Export/PA-logo.svg'
    },
    {
      url: 'https://nv.headed2.com',
      logoSrc: '/images/arkansas/marketing/Images/Export/NV-logo.svg'
    },
    {
      url: 'https://la.headed2.com',
      logoSrc:
        '/images/louisiana/logo/H2-CareerExplorer-Logo-Louisiana-0119-v1_MainDark.svg'
    }
  ]
}
